
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/collections/vendors' && window.location.search === '?q=') {
      window.location.href = 'https://www.aquaprovac.com/collections/replacement-parts-and-accessories'; // Replace 'URL_TO_REDIRECT_TO' with your desired URL
    }
  });

